<div class="container">
  <mat-card class="card">
    <mat-card-header>
      <mat-card-title>{{ 'Players.Title' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-list>
        <mat-list-item *ngFor="let player of players; let idx = index">
          {{ player }}
          <mat-icon aria-hidden="true" class="remove-player" (click)="removePlayer(idx)">close</mat-icon>
        </mat-list-item>
      </mat-list>
      <form [formGroup]="form" (ngSubmit)="addPlayer(form.value)" class="form">
        <mat-form-field>
          <mat-label>{{ 'Players.PlayerName' | translate }}</mat-label>
          <input matInput #message formControlName="name" maxlength="256">
        </mat-form-field>
        <button mat-raised-button color="secondary" type="submit" class="button">{{ 'Add' | translate }}</button>
      </form>
    </mat-card-content>
    <mat-card-actions>
      <button class="next-button" mat-raised-button color="primary" (click)="next()" [disabled]="players.length < 2">{{ 'Next' | translate }}</button>
    </mat-card-actions>
  </mat-card>
</div>